
const auth = {
  'auth.signIn': 'Giriş Yap',
  'auth.signUp': 'Kayıt Ol',
  'auth.signOut': 'Çıkış Yap',
  'auth.profile': 'Profil',
  'auth.forgotPassword': 'Şifrenizi mi unuttunuz?',
  'auth.resetPassword': 'Şifre Sıfırla',
  'auth.noAccount': 'Hesabınız yok mu?',
  'auth.haveAccount': 'Zaten hesabınız var mı?',
  'auth.emailVerification': 'E-posta Doğrulama',
  'auth.emailVerificationSent': 'E-posta adresinize bir doğrulama e-postası gönderildi. Lütfen gelen kutunuzu kontrol edin ve hesabınızı doğrulamak için talimatları takip edin.',
  'auth.emailVerificationInfo': 'Giriş yapabilmeniz için lütfen e-posta adresinizi doğrulayın.',
  'auth.verificationSuccess': 'E-postanız başarıyla doğrulandı!',
  'auth.verificationError': 'E-postanızı doğrularken bir hata oluştu.',
  'auth.passwordRequirements': 'Şifre şunları içermelidir:',
  'auth.passwordLength': 'En az 8 karakter uzunluğunda olmalı',
  'auth.passwordUppercase': 'En az bir büyük harf içermeli',
  'auth.passwordLowercase': 'En az bir küçük harf içermeli',
  'auth.passwordNumber': 'En az bir rakam içermeli',
  'auth.passwordSpecial': 'En az bir özel karakter içermeli',
  'auth.passwordsDoNotMatch': 'Şifreler eşleşmiyor',
  'auth.emailsDoNotMatch': 'E-postalar eşleşmiyor',
  'auth.invalidEmail': 'Lütfen geçerli bir e-posta adresi girin',
  'auth.mandatoryField': 'Bu alan zorunludur',
  'auth.usernameLength': 'Kullanıcı adı 3 ile 20 karakter arasında olmalıdır',
  'auth.usernameFormat': 'Kullanıcı adı yalnızca harf, rakam, alt çizgi ve tire içerebilir',
  'auth.nameFormat': 'Yalnızca harf, boşluk, tire ve kesme işareti içerebilir',
  'auth.nameMaxLength': '50 karakteri geçmemelidir',
  'auth.phoneFormat': 'Lütfen geçerli bir telefon numarası girin',
  'auth.addressFormat': 'Adres geçersiz karakterler içeriyor',
  'auth.addressMaxLength': 'Adres 200 karakteri geçmemelidir',
  'auth.cityFormat': 'Şehir yalnızca harf, boşluk, tire ve kesme işareti içerebilir',
  'auth.cityMaxLength': 'Şehir 100 karakteri geçmemelidir',
  'auth.postalCodeFormat': 'Posta kodu yalnızca harf, rakam, boşluk ve tire içerebilir',
  'auth.postalCodeMaxLength': 'Posta kodu 20 karakteri geçmemelidir',
  'auth.emailMaxLength': 'E-posta adresi çok uzun',
  'auth.passwordMaxLength': 'Şifre 128 karakteri geçmemelidir',
  'auth.phoneMinLength': 'Telefon numarası çok kısa',
  'auth.phoneMaxLength': 'Telefon numarası çok uzun',
  'auth.suspiciousContent': 'Potansiyel olarak zararlı içerik içeriyor',
  'auth.reservedUsername': 'Kullanıcı adı ayrılmıştır',
  'auth.commonPassword': 'Şifre çok yaygın',
  'auth.minimumAge': 'En az 18 yaşında olmalısınız',
  'auth.loginError': 'Geçersiz e-posta veya şifre',
  'auth.loginRequired': 'Profilinizi görmek için lütfen giriş yapın',
  'auth.signUpError': 'Hesap oluşturulurken hata',
  'auth.signOutError': 'Çıkış yapılırken hata',
  'auth.usernameTaken': 'Kullanıcı adı zaten alınmış',
  'auth.emailTaken': 'E-posta zaten kullanılıyor',
  'auth.firstName': 'Ad',
  'auth.lastName': 'Soyad',
  'auth.dateOfBirth': 'Doğum Tarihi',
  'auth.gender': 'Cinsiyet',
  'auth.selectGender': 'Cinsiyet Seçin',
  'auth.male': 'Erkek',
  'auth.female': 'Kadın',
  'auth.other': 'Diğer',
  'auth.preferNotToSay': 'Belirtmek İstemiyorum',
  'auth.phone': 'Telefon Numarası',
  'auth.phoneNumber': 'Telefon numarası',
  'auth.email': 'E-posta',
  'auth.confirmEmail': 'E-posta Onayı',
  'auth.username': 'Kullanıcı Adı',
  'auth.password': 'Şifre',
  'auth.confirmPassword': 'Şifre Onayı',
  'auth.agreeToTerms': 'Kabul ediyorum ',
  'auth.termsOfService': 'Kullanım Koşulları',
  'auth.and': ' ve ',
  'auth.privacyPolicy': 'Gizlilik Politikası',
  'auth.termsRequired': 'Şartlar ve Koşulları kabul etmelisiniz',
  'auth.country': 'Ülke',
  'auth.selectCountry': 'Ülke Seçin',
  'auth.countryCode': 'Ülke Kodu',
  'auth.selectCountryCode': 'Ülke Kodu Seçin',
  'auth.userInfo': 'Kullanıcı Bilgileri',
  'auth.contactInfo': 'İletişim Bilgileri',
  'auth.accountInfo': 'Hesap Bilgileri',
  'auth.welcomeBack': 'The Club\'a Giriş Yap',
  'auth.welcomeMessage': 'Giriş yapmak için kimlik bilgilerinizi girin',
  'auth.createAccount': 'The Club Hesabınızı Oluşturun',
  'auth.createAccountMessage': 'Hesabınızı oluşturmak için aşağıdaki bilgileri doldurun',
  'auth.updateProfile': 'Profili Güncelle',
  'auth.profileUpdated': 'Profil başarıyla güncellendi',
  'auth.profileUpdateError': 'Profil güncellenirken hata',
  'auth.selectDate': 'Bir Tarih Seçin',
  'auth.selectYear': 'Bir Yıl Seçin',
  
  // New translations for password reset
  'auth.resetPasswordInstructions': 'E-posta adresinizi girin, şifrenizi sıfırlamanız için bir bağlantı göndereceğiz.',
  'auth.sendResetEmail': 'Sıfırlama E-postası Gönder',
  'auth.resetEmailSent': 'Sıfırlama E-postası Gönderildi',
  'auth.resetEmailInstructions': 'Şifrenizi sıfırlamak için lütfen e-postanızı kontrol edin.',
  'auth.resetPasswordError': 'Şifre Sıfırlama Hatası',
  'auth.unexpectedError': 'Beklenmeyen bir hata oluştu',
  'auth.createNewPassword': 'Hesabınız için yeni bir şifre oluşturun',
  'auth.newPassword': 'Yeni Şifre',
  'auth.backToSignIn': 'Girişe Dön',
  'auth.passwordResetSuccess': 'Şifre Başarıyla Sıfırlandı',
  'auth.passwordResetSuccessMessage': 'Şifreniz başarıyla sıfırlandı. Giriş sayfasına yönlendirileceksiniz.',
  'auth.invalidResetLink': 'Geçersiz veya süresi dolmuş sıfırlama bağlantısı',
  'auth.tooManyAttempts': 'Çok fazla giriş denemesi. Lütfen daha sonra tekrar deneyin.',
  
  // New translations for multi-step signup
  'auth.signUpWithGoogle': 'Google ile kayıt ol',
  'auth.signUpWithFacebook': 'Facebook ile kayıt ol',
  'auth.orContinueWithEmail': 'Veya e-posta ile devam et',
  'auth.next': 'İleri',
  'auth.back': 'Geri',
  'auth.stepTwoOfTwo': 'Adım 2/2',
  
  // New translations for missing UI elements
  'auth.redirecting': 'Yönlendiriliyor...',
  'auth.emailPlaceholder': 'siz@ornek.com',
  'auth.emailPlaceholderGeneric': 'eposta@ornek.com',
  'auth.invalidRecoveryLink': 'Geçersiz kurtarma bağlantısı. Lütfen yeni bir şifre sıfırlama bağlantısı talep edin.',
  'auth.passwordResetTitle': 'Şifrenizi Sıfırlayın',
  'auth.confirmNewPassword': 'Yeni Şifre Onayı',
  'auth.resetPasswordSubmit': 'Şifreyi Sıfırla',

  // Additional validation messages
  'auth.emailValidationError': 'Lütfen geçerli bir e-posta adresi girin',
  'auth.passwordValidationMinLength': 'Şifre en az 8 karakter uzunluğunda olmalıdır',
  'auth.passwordValidationUppercase': 'Şifre en az bir büyük harf içermelidir',
  'auth.passwordValidationNumber': 'Şifre en az bir rakam içermelidir',
  'auth.passwordValidationSpecial': 'Şifre en az bir özel karakter içermelidir',
  'auth.passwordValidationMatch': 'Şifreler eşleşmiyor',

  // Reset password specific messages
  'auth.verifyingRecoveryLink': 'Kurtarma bağlantısı doğrulanıyor...',
  'auth.unableToVerifySession': 'Kurtarma oturumu doğrulanamıyor. Lütfen yeni bir şifre sıfırlama bağlantısı talep edin.',
  'auth.unableToVerifyLink': 'Kurtarma bağlantısı doğrulanamıyor. Lütfen yeni bir şifre sıfırlama bağlantısı talep edin.',
  'auth.invalidRecoverySession': 'Geçersiz kurtarma oturumu. Lütfen yeni bir şifre sıfırlama bağlantısı talep edin.',
  'auth.requestNewResetLink': 'Yeni Sıfırlama Bağlantısı Talep Et',

  // General UI messages
  'auth.emailVerifiedSignIn': 'E-postanız doğrulandı. Lütfen kimlik bilgilerinizle giriş yapın.',
  'auth.unexpectedErrorOccurred': 'Beklenmeyen bir hata oluştu',

  //Supabase Error Messages
  // Authentication errors
  'auth.supabase.invalidCredentials': 'Geçersiz e-posta veya şifre',
  'auth.supabase.emailNotConfirmed': 'Giriş yapmadan önce lütfen e-posta adresinizi doğrulayın',
  'auth.supabase.userNotFound': 'Bu e-posta adresiyle kayıtlı hesap bulunamadı',
  'auth.supabase.passwordTooShort': 'Şifre en az 6 karakter uzunluğunda olmalıdır',
  'auth.supabase.userAlreadyRegistered': 'Bu e-posta ile zaten bir hesap mevcut',
  'auth.supabase.emailRateLimit': 'Çok fazla e-posta gönderildi. Lütfen yeni bir tane talep etmeden önce bekleyin',
  'auth.supabase.invalidEmail': 'Lütfen geçerli bir e-posta adresi girin',
  'auth.supabase.signupDisabled': 'Yeni hesap kaydı şu anda devre dışı',
  'auth.supabase.invalidRecoveryToken': 'Geçersiz şifre kurtarma bağlantısı',
  'auth.supabase.tokenExpired': 'Bu bağlantının süresi dolmuş. Lütfen yeni bir şifre sıfırlama talep edin',
  'auth.supabase.passwordTooWeak': 'Şifre çok zayıf. Lütfen daha güçlü bir şifre seçin',

  // Database errors
  'auth.supabase.databaseError': 'Veritabanı bağlantı hatası. Lütfen daha sonra tekrar deneyin',
  'auth.supabase.connectionTimeout': 'Bağlantı zaman aşımı. Lütfen internet bağlantınızı kontrol edin',
  'auth.supabase.internalError': 'Dahili sunucu hatası. Lütfen daha sonra tekrar deneyin',
  'auth.supabase.serviceUnavailable': 'Hizmet geçici olarak kullanılamıyor. Lütfen daha sonra tekrar deneyin',
  'auth.supabase.requestTimeout': 'İstek zaman aşımı. Lütfen tekrar deneyin',
  
  // Policy/Permission errors
  'auth.supabase.permissionDenied': 'Erişim reddedildi. Bu işlemi gerçekleştirme izniniz yok',
  'auth.supabase.accessDenied': 'Erişim reddedildi',
  'auth.supabase.insufficientPermissions': 'Bu işlemi tamamlamak için yeterli izin yok',
  
  // Network errors
  'auth.supabase.networkError': 'Ağ bağlantı hatası. Lütfen internet bağlantınızı kontrol edin',
  'auth.supabase.connectionError': 'Bağlantı hatası. Lütfen tekrar deneyin',
  
  // Generic patterns
  'auth.supabase.rateLimit': 'Çok fazla istek. Lütfen tekrar denemeden önce bir süre bekleyin',
  'auth.supabase.invalidToken': 'Geçersiz kimlik doğrulama token\'ı. Lütfen tekrar giriş yapın',
  'auth.supabase.resourceNotFound': 'İstenen kaynak bulunamadı',
  'auth.supabase.resourceAlreadyExists': 'Bu kaynak zaten mevcut',
  
  // Generic fallback
  'auth.supabase.genericError': 'Beklenmeyen bir hata oluştu. Lütfen tekrar deneyin',

  // Invitation code field
  'auth.sponsor': 'Davet Kodu',
  'auth.sponsorMandatory': '(zorunlu)',
  'auth.sponsorPlaceholder': 'Davet kodunuzu girin',
  'auth.sponsorNotFound': 'Geçersiz davet kodu. Lütfen geçerli bir kod girin',
  'auth.sponsorRequired': 'Geçerli bir davet kodu gereklidir',
  'auth.needSponsor': 'Davet koduna mı ihtiyacınız var? Bir The Club temsilcisiyle iletişime geçin',

  // Email confirmation error
  'auth.confirmationFailed': 'E-posta onayı başarısız oldu. Lütfen en son onay bağlantısı için e-postanızı kontrol edin.',
  'auth.resendConfirmationEmail': 'Onay E-postasını Tekrar Gönder',
  'auth.resendIn': '{{seconds}} saniye sonra tekrar gönder',
  'auth.resendSuccess': 'Onay e-postası gönderildi! Lütfen gelen kutunuzu kontrol edin.',
  'auth.enterEmailToResend': 'Onay bağlantısını tekrar göndermek için e-postanızı girin',

  // Smart confirmation flow
  'auth.emailNeedsConfirmation': 'Bu e-postanın onaylanması gerekiyor. Yakın zamanda bir onay bağlantısı gönderildi — lütfen gelen kutunuzu kontrol edin.',
  'auth.emailConfirmationResent': 'Bu e-postanın onaylanması gerekiyor. Yeni bir onay e-postası gönderildi — lütfen en son bağlantı için gelen kutunuzu kontrol edin.',
  'auth.confirmationRecentlySent': 'Bu e-postaya yakın zamanda bir onay bağlantısı gönderildi. Lütfen gelen kutunuzu kontrol edin.',
  'auth.confirmationNewSent': 'Yeni bir onay e-postası gönderildi. Lütfen en son onay bağlantısı için gelen kutunuzu kontrol edin.',
  'auth.confirmationSentTo': 'Onay e-postası gönderildi:',
  'auth.verifyEmailResendInfo': 'E-postayı almadınız mı?',

  // Already confirmed messages
  'auth.emailAlreadyConfirmed': 'E-posta adresiniz zaten doğrulanmış. Kimlik bilgilerinizle giriş yapabilirsiniz.',
  'auth.emailAlreadyConfirmedSignIn': 'E-postanız zaten doğrulanmış. Lütfen aşağıdan giriş yapın.',
};

export default auth;
